module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('f7-searchbar', {
    staticClass: "search",
    attrs: {
      "cancel-link": "Cancel",
      "placeholder": "Search in Drafts",
      "search-list": "#draft-list"
    },
    on: {
      "searchbar:search": _vm.onSearch,
      "searchbar:clear": _vm.onClear
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('cm-draft-list', {
    attrs: {
      "drafts": _vm.drafts
    }
  }), _vm._v(" "), _c('cm-pagination', {
    attrs: {
      "firstIndex": _vm.draftsPaginationObject.firstIndex,
      "maxResultsByPage": _vm.draftsPaginationObject.maxResults,
      "nbResultsTotal": _vm.draftsPaginationObject.nbResultsTotal,
      "refreshEvent": _vm.draftsPaginationObject.refresh
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7c236f8e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c236f8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/services/directPayments/sendbox/Drafts.vue
// module id = 1699
// module chunks = 2